import React, { PureComponent } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import PropTypes from 'prop-types';
import { empty, identity } from 'ramda';
import { Container, Title, SwipableList, Link, TitlePlaceholder, SubTitlePlaceholder } from './experiencesList.styles';
import { renderWhenNotNil, renderWhenTrueOtherwise } from '../../../shared/utils/rendering';
import { InlineList } from './inlineList';
import { experiencePropType } from '../../../propTypes';
import { matchBreakpoint } from '../../../theme/getters';
import { Breakpoints } from '../../../theme/media';

export class ExperiencesList extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    experiences: PropTypes.arrayOf(experiencePropType),
    title: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    rowLayout: PropTypes.bool,
    limitedCount: PropTypes.bool,
    placeholder: PropTypes.bool,
    visibilitySensorActive: PropTypes.bool,
    indexModifier: PropTypes.func,
    onViewportEnter: PropTypes.func,
  };

  static defaultProps = {
    rowLayout: false,
    experiences: [],
    onViewportEnter: empty,
    indexModifier: identity,
  };

  state = {
    isVisibilitySensorActive: this.props.visibilitySensorActive || false,
  };

  get experiences() {
    if (!this.props.limitedCount) {
      return this.props.experiences;
    }

    const limitSize = matchBreakpoint(Breakpoints.TABLET)(this.props) ? 3 : 4;
    return this.props.experiences.slice(0, limitSize);
  }

  handleVisibilityChange = isVisible => {
    if (this.state.isVisibilitySensorActive && isVisible) {
      this.setState({ isVisibilitySensorActive: false });
      this.props.onViewportEnter(this.experiences);
    }
  };

  renderTitle = renderWhenTrueOtherwise(
    () => <TitlePlaceholder />,
    () => renderWhenNotNil(() => <Title>{this.props.title}</Title>)(this.props.title)
  );

  renderSubTitle = () => {
    if (!this.props.linkLabel || !this.props.linkUrl) {
      return null;
    }

    return renderWhenTrueOtherwise(
      () => <SubTitlePlaceholder />,
      () => <Link to={this.props.linkUrl}>{this.props.linkLabel}</Link>
    )(this.props.placeholder);
  };

  render = () => {
    const ListComponent = this.props.rowLayout && this.props.experiences.length > 1 ? SwipableList : InlineList;
    return (
      <VisibilitySensor
        partialVisibility
        active={this.state.isVisibilitySensorActive}
        onChange={this.handleVisibilityChange}
        minTopValue={200}
      >
        <Container className={this.props.className}>
          {this.renderTitle(this.props.placeholder)}
          {this.renderSubTitle()}
          <ListComponent
            indexModifier={this.props.indexModifier}
            placeholder={this.props.placeholder}
            experiences={this.experiences}
          />
        </Container>
      </VisibilitySensor>
    );
  };
}
